<template>
  <div class="settings_right">
    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="searchtxt"
            placeholder="Search by Name"
            class="is-label-placeholder"
          />
        </div>
      </div>
      <div class="content-header-right">
        <vs-inv-dropdown >
        <!-- <vs-dropdown vs-custom-content vs-trigger-click>
          <vs-button
            color="primary"
            class="filter-btn"
            type="border"
            icon-pack="feather"
            icon="icon-chevron-down"
            icon-after
          >
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content settings_filters"> -->
            <div class="filters-content">
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Setup Status</label>

                    <multiselect
                      v-model="selected_config_completed_statusids"
                      :options="all_config_status"
                      :multiple="true"
                      :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :select-label="''"
                      :preserve-search="true"
                      placeholder="Select Setup Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Setup Status Selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  <div
                    class="vx-col md:w-1/3 w-full con-select"
                    v-if="[1].indexOf(getUserRoleId) > -1"
                  >
                    <label class="typo__label">Select Customers</label>

                    <multiselect
                      v-model="filteredTenants"
                      :options="tenantsList"
                      :multiple="true"
                      :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Customers"
                      label="name"
                      track-by="_id"
                      :preselect-first="false"
                    >
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Customer(s) Selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Active Status</label>

                    <multiselect
                      v-model="selected_active_statusids"
                      :options="all_active_status"
                      :multiple="true"
                      :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :select-label="''"
                      :preserve-search="true"
                      placeholder="Select  Active Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <!-- <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                          options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Active Status Selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  <!--
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Status</label>
                    
                    <multiselect v-model="selected_statusids" :options="all_status" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Status Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  -->

                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker
                      :maxDate="new Date()"
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_createdDateRange"
                    ></date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons"></div>
              <div class="right-buttons">
                <vs-button
                  color="success"
                  class="save"
                  type="filled"
                  v-on:click="set_filter()"
                  >Apply</vs-button
                >
                <vs-button
                  color="dark"
                  class="cancel"
                  type="filled"
                  v-on:click="clear_filter($event)"
                  >Clear
                </vs-button>
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu> -->
        <!-- </vs-dropdown> -->
      </vs-inv-dropdown>

        <vs-button
          type="border"
          v-if="[1].indexOf(getUserRoleId) > -1"
          class="light-blue-btn"
          @click="createNew(true);$validator.reset()"
          >Add New
          <span>
            <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg" />
          </span>
        </vs-button>
      </div>
    </div>
    <NoDataFound
      ref="NoDataFoundRef"
      v-if="list.length == 0"
      content=""
      :heading="'No Questionnaire Templates Found'"
      type="questionnaire"
    />
    <div class="accordian-table" v-if="list.length > 0">
      <vs-table :data="list" :no-data-text="'No data found..!'">
        <template slot="thead" v-if="list.length > 0">
          <vs-th>
            <a
              @click="sortMe('name')"
              v-bind:class="{
                sort_ascending: sortKeys['name'] == 1,
                sort_descending: sortKeys['name'] != 1,
              }"
            >
              Name
            </a>
          </vs-th>
          <vs-th v-if="filteredTenants.length > 0">Customer</vs-th>
          <vs-th> Total Cases </vs-th>
          <!-----
          <vs-th>
          <a @click="sortMe('createdByName')"  v-bind:class="{'sort_ascending':sortKeys['createdByName']==1, 'sort_descending':sortKeys['createdByName']!=1}" >
           
           Created By
           </a>
              
          </vs-th>
        -->
          <vs-th>
            <a
              @click="sortMe('createdOn')"
              v-bind:class="{
                sort_ascending: sortKeys['createdOn'] == 1,
                sort_descending: sortKeys['createdOn'] != 1,
              }"
            >
              Created On
            </a>
          </vs-th>
          <vs-th>
            <a
              @click="sortMe('updatedOn')"
              v-bind:class="{
                sort_ascending: sortKeys['updatedOn'] == 1,
                sort_descending: sortKeys['updatedOn'] != 1,
              }"
            >
              Updated On
            </a>
          </vs-th>

          <vs-th>Setup Status</vs-th>
          <vs-th>Active Status</vs-th>
          <vs-th class="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.username" class="td_label">
              <!--
              <img class="user-image" src="@/assets/images/main/avatar2.svg" />
              -->
              {{ tr.name }}
              <small v-if="checkProperty(tr, 'refId') != ''">(Global)</small>
            </vs-td>

            <vs-td
              v-if="filteredTenants.length > 0"
              :title="checkProperty(tr, 'tenantDetails', 'name')"
              ><div class="td_text">
                {{ checkProperty(tr, "tenantDetails", "name") | subString }}
              </div></vs-td
            >
            <vs-td
              ><span class="count">{{
                checkProperty(tr, "petitionCount")
                  ? checkProperty(tr, "petitionCount")
                  : 0
              }}</span></vs-td
            >
            <!-- <vs-td >{{tr.createdByName  }}</vs-td >-->
            <vs-td>{{ tr.createdOn | formatDate }}</vs-td>
            <vs-td>{{ tr.updatedOn | formatDate }}</vs-td>

            <vs-td>
              <span
                class="statusspan"
                :class="{
                  status_pending: !tr.configCompleted,
                  status_active: tr.configCompleted,
                }"
              >
              </span>
              {{ tr.configCompleted ? "Complete" : "Pending" }}
            </vs-td>
            <vs-td>
              <span
                class="statusspan"
                :class="{ status_pending: !tr.active, status_active: tr.active }"
              >
              </span>
              {{ tr.active ? "Active" : "Inactive" }}
            </vs-td>

            <vs-td>
              <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                <a class="a-icon" href.prevent
                  ><more-vertical-icon
                    size="1.5x"
                    class="custom-class"
                  ></more-vertical-icon
                ></a>
                <vs-dropdown-menu class="loginx msg_dropdown">
                  <vs-dropdown-item
                    ><a href.prevent @click="showView(true, tr, 'view')">View</a>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-if="
                      [1, 3].indexOf(getUserRoleId) > -1 &&
                      !checkProperty(tr, 'petitionCount')
                    "
                    ><a href.prevent @click="showView(true, tr, 'edit')">Edit</a>
                  </vs-dropdown-item>

                  <!--
                       <vs-dropdown-item>
                      <router-link  :to="'/questionnaire-template-details/'+tr._id">  <p style="cursor:pointer" >View</p></router-link>
                    </vs-dropdown-item>
                    
                       <vs-dropdown-item v-if="[1 ,3 ].indexOf(getUserRoleId)>-1 && tr.petitionCount <=0">
                      <router-link   :to="'/questionnaire-template/'+tr._id">  <p style="cursor:pointer" >Edit</p></router-link>
                    </vs-dropdown-item> -->
                  <vs-dropdown-item v-if="[1, 3].indexOf(getUserRoleId) > -1">
                    <a href.prevent @click="cloneMe(tr)">Clone</a>
                  </vs-dropdown-item>

                  <vs-dropdown-item v-if="tr.configCompleted">
                    <a href="#">
                      <p style="cursor: pionter" @click="openPopUp(tr)">
                        <template v-if="tr['active']">Inactive</template>
                        <template v-if="!tr['active']"> Activate</template>
                      </p>
                    </a>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <paginate
        v-if="list.length > 0"
        v-model="page"
        :page-count="totalpages"
        :page-range="3"
        :margin-pages="2"
        :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
        :prev-text="'<i></i>'"
        :next-text="'<i></i>'"
        :container-class="'pagination vs-pagination--nav'"
        :page-class="'page-item'"
      ></paginate>
    </div>

    <div class="workflow_view_wrap" :class="{ listopen: showWorkflowview }">
      <div class="workflow_overlay" @click="showView(false)"></div>
      <div class="workflow_view_cnt questionary_cnt questionary_admin_cnt" style="width:90%">
        <div class="workflow_view_title" :class="{ 'view__title': type == 'view' }">
          <!-- <label> Questionnaire Template </label>-->
          <div>
            <label v-if="checkProperty(selectedItem, 'name')"
              >{{ checkProperty(selectedItem, "name") }}
            </label>
          </div>
          <button
            v-if="type == 'edit'"
            @click="showView(false)"
            class="cancel"
            type="filled"
          >
            Cancel
          </button>
          <span v-if="type == 'view'" @click="showView(false)"
            ><x-icon size="1.5x" class="custom-class"></x-icon
          ></span>
        </div>
        <div>
          
          <template v-if="type == 'view'">
            <h4eadQuestionnaireTpl
            v-if="['h4-ead', 'l2' ].indexOf(checkProperty(selectedItem, 'entityType')) >-1"
            @gotoList="gotoList" :isEdit="false" :entityType="checkProperty(selectedItem, 'entityType')"
            :templateId="checkProperty(selectedItem, '_id')"

            />
            <template v-if="['case','I-130', 'L-VISA'].indexOf(checkProperty(selectedItem, 'entityType')) >-1" >
                <QuestionnaireTemplate
                  @gotoList="gotoList" :isEdit="false"
                  :templateId="checkProperty(selectedItem, '_id')" :entityType="checkProperty(selectedItem, 'entityType')"
              /></template>
              <template v-if="checkProperty(selectedItem, 'entityType') == 'perm'" >
                <PermQuestionnaireTemplate
                  @gotoList="gotoList" :isEdit="false"
                  :templateId="checkProperty(selectedItem, '_id')"
                />
              </template>
          </template>
          <template v-if="type == 'edit'">
            <div>
              <h4eadQuestionnaireTpl v-if="['h4-ead', 'l2' ].indexOf(checkProperty(selectedItem, 'entityType')) >-1"
            @gotoList="gotoList" :isEdit="true" :entityType="checkProperty(selectedItem, 'entityType')"
            :templateId="checkProperty(selectedItem, '_id')"

            />
              <template v-if="[ 'case','I-130', 'L-VISA'].indexOf(checkProperty(selectedItem, 'entityType')) >-1" >
                <QuestionnaireTemplate
                  @gotoList="gotoList" :isEdit="true"
                  :templateId="checkProperty(selectedItem, '_id')" :entityType="checkProperty(selectedItem, 'entityType')"
              /></template>
              
              <template v-if="checkProperty(selectedItem, 'entityType') == 'perm'" >
                <PermQuestionnaireTemplate
                  @gotoList="gotoList" :isEdit="true"
                  :templateId="checkProperty(selectedItem, '_id')"
                />
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <vs-popup
      class="holamundo main-popup"
      title="Delete form and letters"
      :active.sync="approveConformpopUp"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            {{ actionText }}
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="approveConformpopUp = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="save"
          type="filled"
          @click="deleteformandLetter()"
          >Delete</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo main-popup"
      :title="edit ? 'Edit Questionnaire Template ' : 'Add Questionnaire Template'"
      v-if="addPopup"
      :active.sync="addPopup"
    >
      <form  @submit.prevent data-vv-scope="templateForm">
        <div class="form-container">
          <div class="vx-row" @click="formerrors.msg = ''">
           
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Template Type<em>*</em></label>
                <div class="con-select">
                  <multiselect
                    v-model="newform.entityTypeDetails"
                    v-validate="'required'"
                    :options="templateList"
                    :hideSelected="false" 
                    data-vv-as="Template Type"
                    name="Template Type"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Template Type"
                    label="tempName"
                    track-by="tempName"
                    :preselect-first="true"
                  >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                      Types selected</span>
                    <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                  </template>
                  </multiselect>
                </div>
                <span class="text-danger text-sm" v-show="errors.has('templateForm.Template Type')">{{
                  errors.first("templateForm.Template Type") }}</span>
              </div>
            </div>
            
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Template Name<em>*</em></label>
                <vs-input
                  @click="formerrors.msg = ''"
                  v-model="newform.name"
                  name="Template Name"
                  v-validate="'required'"
                  class="w-full"
                  data-vv-as="Template Name"
                />
                <span class="text-danger text-sm" v-show="errors.has('templateForm.Template Name')">{{
                  errors.first("templateForm.Template Name")
                }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row" v-if="[1].indexOf(getUserRoleId) > -1">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Customer</label>

                <div class="con-select">
                  <multiselect
                    v-model="selectedTenant"
                    :options="tenantsList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Customer"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                      >
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                      ></span>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-danger text-sm formerrors"
            v-show="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        
        <div class="popup-footer relative">
            <figure v-if="creatingTpl" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
          
          <vs-button
            color="dark"
            @click="
              edit = false;
              createNew(false);newform.name='';
            "
            class="cancel"
            type="filled"
            >Cancel</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm"
            class="save"
            v-if="edit"
            @click="ConfigTemplate()"
            type="filled"
            >Update</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm"
            class="save"
            v-else
            @click="createConfigTemplate()"
            type="filled"
            >Save</vs-button
          >
        </div>
      </form>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      :title="'Clone Questionnaire Template'"
      v-if="clonePopup"
      :active.sync="clonePopup"
    >
      <form>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Template Name<em>*</em></label>
                <vs-input
                  @click="formerrors.msg = '';newform.name=''"
                  v-model="newform.name"
                  name="Config Template Name"
                  v-validate="'required'"
                  class="w-full"
                  data-vv-as="Template Name"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Config Template Name')"
                  >{{ errors.first("Config Template Name") }}</span
                >
              </div>
            </div>
          </div>

          <div class="vx-row" v-if="[1].indexOf(getUserRoleId) > -1">
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Customer</label>

                <div class="con-select">
                  <multiselect
                    v-model="selectedTenant"
                    :options="tenantsList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Customer"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Customer(s) Selected</span
                      >
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                      ></span>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-danger text-sm formerrors"
            v-show="formerrors.msg"
            @click="formerrors.msg = ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formerrors.msg }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer">
          <vs-button color="dark" @click="createNew(false)" class="cancel" type="filled"
            >Cancel</vs-button
          >
          <vs-button
            color="success"
            :disabled="validateForm"
            class="save"
            @click="cloneTemplate()"
            type="filled"
            >Clone</vs-button
          >
        </div>
      </form>
    </vs-popup>

    <vs-popup
      class="holamundo main-popup"
      :title="
        (checkProperty(selectedItem, 'active') ? 'Inactivate ' : ' Activate') + 'Template'
      "
      :active.sync="activatePopUp"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p>
              Are you sure of
              {{ checkProperty(selectedItem, "active") ? "inactivating" : "activating " }}
              this template?
            </p>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="activatePopUp = false"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="save"
          type="filled"
          @click="activateTemplate()"
          >{{
            checkProperty(selectedItem, "active") ? "Inactivate " : " Activate"
          }}</vs-button
        >
      </div>
    </vs-popup>
   
  </div>
</template>

<script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import Paginate from "vuejs-paginate";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import _ from "lodash";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import PhoneMaskInput from "vue-phone-mask-input";
import JQuery from "jquery";
import { TheMask } from "vue-the-mask";
import { XIcon } from "vue-feather-icons";
import FileUpload from "vue-upload-component/src";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { MoreVerticalIcon } from "vue-feather-icons";
import NoDataFound from "@/views/common/noData.vue";
import questionnaireTemplateDetails from "@/views/questionnaireTemplateDetails.vue";
import QuestionnaireTemplateCreate from "@/views/QuestionnaireTemplateCreate.vue";

// New Templates
import QuestionnaireTemplate from "@/views/Questionnaire/QuestionnaireTemplate.vue";
import PermQuestionnaireTemplate from "@/views/Questionnaire/PermQuestionnaireTemplate.vue";
import h4eadQuestionnaireTpl from "@/views/Questionnaire/h4eadQuestionnaireTpl.vue";



export default {
  computed: {
    validateForm() {
      if (this.newform.name && this.newform.name.trim() != "") {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {
    vsInvDropdown,
     QuestionnaireTemplate,
     PermQuestionnaireTemplate,
     h4eadQuestionnaireTpl,
    
    NoDataFound,
    DateRangePicker,
    VuePhoneNumberInput,
    Datepicker,
    Paginate,
    FileUpload,
    FormWizard,
    TabContent,
    PhoneMaskInput,
    TheMask,
    MoreVerticalIcon,
    questionnaireTemplateDetails,
    QuestionnaireTemplateCreate,
    XIcon,
  },

  data: () => ({
    petitionerInfoModal:[
      { 
        key: "benfComeToUSOpenNewOffice",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "classificationScougt",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      }, 
      { 
        key: "nameOfEmpAbroad",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "address",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "dateOfBenfEmployment",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "explaOfInterruptions",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "dateOfEmpFrom",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "dateOfEmpTo",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.dateOfBenfEmployment",
      },
      { 
        key: "descBenfDutAbroad3Years",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "descBenfPropDutiesInUs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "sumBenfEduAndWorkExp",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "companyRelaToAbroad",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "desPerStockOwnerShip",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.desPerStockOwnerShip",
      },
      { 
        key: "perOfCompany",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.desPerStockOwnerShip",
      },
      { 
        key: "fedEmpIdentification", 
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.desPerStockOwnerShip",
      },
      { 
        key: "everqualRelaOneYearEmpl",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "everqualRelaOneYearEmplExpla",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "benePriOffsiteEmp",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "priOffsiteEmpExpla",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "priReasplaceToAnotWorksite",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo",
      },
      { 
        key: "incorporationCertDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "amendmentCertDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "stockCopyCertDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "leaAgreeForPropOffice",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "curOrgaChart",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "propOrgaChart",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "l1AVisaBusiPlan",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "minOfBoardMeetings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "contraExecOfCopyDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "auditFinaStatMostRecent",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "bankIndicAndBal",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "productDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.usaCompanyDocuments",
      },
      { 
        key: "taxReturns",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "bankStatements",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "verifyOrSupportLetter",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "orgnaStructureDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
      { 
        key: "proAndLossStatDocs",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "petitionerQuestInfo.foreignCompanyDocuments",
      },
     
    ],
    sponsorInfo:[
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "sponsorInfo.motherInfo"
      },
    { 
        key: "haveUSCitizenOrPermResident",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
     { 
        key: "filingThisPetitionerFor",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      // Newly added i-130 keys starts
      { 
        key: "fillThisPetiChildOrParentRelation",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "fillThisBroOrSisRelatedByAdoption",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "gainLawPermResidentThroughAdoption",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "classOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.lawFulPermanentResident",
      },
      { 
        key: "dateOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.lawFulPermanentResident",
      },
      { 
        key: "cityOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "stateOfAdmission",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "anyOtherElseFiledPetitionForBnf",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "benfEverInImmigrationProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "typeOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "dateOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "stateOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "cityOfProceedings",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "haveYouPrevFiledAnyPetitionForBnf",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "familyName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "givenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "dateOfFiling",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "cityOfFiling",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "stateOfFiling",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "status",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.bnfPrevPetitionInfo",
      },
      { 
        key: "hasSubmitSepPetiForOtherRelation",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      { 
        key: "relative",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "familyName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "givenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      { 
        key: "relationShip",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.submitSupPetiForOtherRelative",
      },
      // end
    { 
        key: "anyOtherPersonEmployedInUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
      {
        key: "haveYouEverEmployed",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
  {
    "key": "gender",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "previouslyMarried",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "fatherInfo",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "fatherInfo",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
          key: "dateOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "sponsorInfo",
        },
        {
        key: "citizenshipAcquiredThrough",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
        {
    key: "locationOfMarriage",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo",
  },
        {
    key: "provinceOfMarriage",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo",
  },
        {
    key: "countryOfMarriage",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo",
  },
  {
          key: "countryOfBirth",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "sponsorInfo",
        },
  {
    "key": "otherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "spouse",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "hasSpouse",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "nameDiffFromBirthCert",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "hasOtherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "birthCertHaveNamePobDob",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "have2AffidavitsOfBirthFamily",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "mailingAddressIsSameAsAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "address",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "address",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "cellPhoneNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "email",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "SSN",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "alienNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "placeOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "placeOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "provinceOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "provinceOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "maritalStatus",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "usCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "citizenshipBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "citizenshipNaturalization",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "citizenshipParents",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "lawfulPerResident",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "lprRequired",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "certOfCitizenNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateReceivedLPR",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "placeOfIssuance",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateOfIssuance",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "usCitizenOrLPR",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "height",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.height"
  },
  {
    "key": "feet",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.height"
  },
  {
    "key": "inches",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.height"
  },
  {
    "key": "weight",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "race",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "eyeColor",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "hairColor",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "nationality",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "dateFromUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedOnAnyOtherPerOrPetitioner",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedPlace",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "fileDateOfFiling",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "filedStatus",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
        key: "addressOfLastNYears",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOfLastNYears",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOfLastNYears",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOfLastNYears",
      },
      {
        key: "addressOutsideUSMoreThanYear",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOutsideUSMoreThanYear",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOutsideUSMoreThanYear",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.addressOutsideUSMoreThanYear",
      },
  {
    "key": "previousSpouse",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
  key: "marriageEndedOtherInfo",
  lebel: "",
  required: true,
  description: "",
  fieldRequired:true,
  section: "sponsorInfo.previousSpouse",
},
 {
      key: "previousSpouse",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "firstName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "middleName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "lastName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "name",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "maidenName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "dateOfBirth",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "dateOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "dateOfMarriageEnd",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriageDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriageDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "locationOfMarriage",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriageTermination",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "countryOfMarriageTerminationDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriageTermination",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "provinceOfMarriageTerminationDetails",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "locationOfMarriageTermination",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key: "obtainPermResidenceThroughSpouse",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.previousSpouse",
    },
    {
      key : "marriageEndedDueTo",
      lebel : "",
      required : true,       
      fieldRequired:true,
      description : "",
      section : "sponsorInfo.previousSpouse"
    },
    {
      key: "maidenName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.dependentsInfo.spouse",
    },
    {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "provinceOfBirth", 
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "sponsorPassport",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "sponsorGreenCard",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "sponsorBirthCertificate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "sponsorPhotographs",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.documents"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "placeOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "placeOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "alienNumber",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "currentStatus",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "currentStatus",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "passportExpiryDate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.spouse"
  },
  {
    "key": "passport",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "marriageCertificate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "birthCertificate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "marriagePhotographs",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "affidavits",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "martialRelationship",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "photographs",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.spouse.documents"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "otherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "hasOtherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.otherNames"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.otherNames"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.otherNames"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.nameAtBirth"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.nameAtBirth"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo.nameAtBirth"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "countryOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "provinceOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "provinceOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "isUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "dateFromUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "deceasedCity",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "deceasedCityDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "deceasedDate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.fatherInfo"
  },
  {
    "key": "motherInfo",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "otherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
 
  {
    "key": "hasOtherNames",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.otherNames"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.otherNames"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.otherNames"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.nameAtBirth"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.nameAtBirth"
  },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo.nameAtBirth"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "countryOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "countryOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "provinceOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "provinceOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "locationOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "currentAddress",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "isUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "dateFromUSCitizen",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "deceasedCity",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "deceasedCityDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "deceasedDate",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.motherInfo"
  },
  {
    "key": "uuid",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "hasChildren",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "children",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo"
  },
  {
  "key": "locationOfBirth",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "sponsorInfo.dependentsInfo.children"
},
{
  "key": "provinceOfBirth", 
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "sponsorInfo.dependentsInfo.children"
},
  {
    "key": "name",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "firstName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "middleName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
      key: "maidenName",
      lebel: "",
      required: true,
      description: "",
      fieldRequired:true,
      section: "sponsorInfo.dependentsInfo.children",
    },
  {
    "key": "lastName",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "dateOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "placeOfBirth",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "placeOfBirthDetails",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
    "key": "relationshipToYou",
    "lebel": "",
    "required": true,
    "description": "",
    "fieldRequired": true,
    "section": "sponsorInfo.dependentsInfo.children"
  },
  {
  "key": "countryOfBirth",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "sponsorInfo.dependentsInfo.children"
},
{
        key: "countryOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo",
      },
{
        key: "prevEmploymentInfo",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "employerName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo", 
      },
      {
        key: "salary",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "payFrequency",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },

      {
        key: "address",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "businessType",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "jobTitle",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "jobDuties",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "currentEmployer",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentInfo",
      },
      {
        key: "prevEmploymentOutsideUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "employerName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS", 
      },
      {
        key: "salary",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "payFrequency",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },

      {
        key: "address",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "businessType",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "jobTitle",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "jobDuties",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "startDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "endDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
        key: "currentEmployer",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "sponsorInfo.prevEmploymentOutsideUS",
      },
      {
    key: "affidavitInfo",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "benfAdjustmentDocument",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "benfApplyAdjustStatus",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "currentAnnualSalary",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "nameOfEmployer",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "currentPosition",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "depositsInBankUSA",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "reasonableValPersonalProperty",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "haveMarketValInStocksAndBonds",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "marketValInStocksAndBonds",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "sumOfLifeInsurance",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "cashSurrValOfLifeInsurance",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "haveValOfRealEstate",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "valOfRealEstate",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "amountOfMortgageProperty",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
    key: "addressPropertyIsLocate",
    lebel: "",
    required: true,
    description: "",
    fieldRequired:true,
    section: "sponsorInfo.affidavitInfo",
  },
  {
          key: "haveYouEverEmployed",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "sponsorInfo",
        },




    ],

    type: "",
    showWorkflowview: false,
    callFromSerch: false,
    activatePopUp: false,
    all_status: [
      { name: "Active", id: true },
      { name: "Inactive", id: false },
    ],
    all_active_status: [
      { name: "Active", id: true },
      { name: "Inactive", id: false },
    ],
    all_config_status: [
      { name: "Complete", id: true },
      { name: "Pending", id: false },
    ],
    selected_active_statusids: [],
    final_active_statusids: [],

    selected_createdDateRange: ["", ""],
    autoApply: "",
    value: [],
    all_formTypes: [
      { name: "Form", id: "Form" },
      { name: "Letter", id: "Letter" },
    ],

    selectedItem: null,
    tenantsList: [],
    templateList: [
      { name: "Case", id: 1,tempName:'Case (h1-b, I-140,..)' },
      { name: "PERM", id: 2,tempName:'PERM' },
      { name: "H4-EAD", id: 3,tempName:'H4' },
      { name: "Case I-130", id: 4,tempName:'I-130' },
      { name: "L-VISA", id: 5,tempName:'L-VISA' },
      { name: "L2", id: 6,tempName:'L2' },
    ],
    selectedTenant: null,
    selectedTemplateType: null,
    filteredTenants: [],
    finalFilteredTenants: [],
    selectedStatus: 2,
    actionText: "Do you want to Delete?",
    formerrors: {
      msg: "",
    },
    date: null,
    approveConformpopUp: false,
    h4Eadfields: [

      {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        key: 'doYouAlreadyH4EAD',
        description:'',      
        fieldRequired: true,
        "required": true,
        "section":'beneficiaryInfo'
      },  
      {
            key: 'doYouAlreadyL2EAD',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'beneficiaryInfo'
          }, 
          {
            key: 'l2EADRequired', 
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'beneficiaryInfo'
          }, 
          {
            "key": "I94ExpiryDate",
            "lebel": "",
            "required": false,
            "description": "",
            "fieldRequired": false,
            "section": "beneficiaryInfo"
          }, 
          {
            "key": "stateOfLastEntryInUS",
            "lebel": "",
            "required": false,
            "description": "",
            "fieldRequired": false,
            "section": "beneficiaryInfo"
          },
          {
            "key": "h1bSpouseApprNumber",
            "lebel": "",
            "required": false,
            "description": "",
            "fieldRequired": false,
            "section": "beneficiaryInfo"
          },
          {
            "key": "l1SpouseApprNumber",
            "lebel": "",
            "required": false,
            "description": "",
            "fieldRequired": false,
            "section": "beneficiaryInfo"
          },
      {
        key: 'h4EADRequired',
        description:'',      
        fieldRequired: true,
        "required": true,
        "section":'beneficiaryInfo'
      }, 
      {
        key: 'applyingPetitionFor',
        description:'',      
        fieldRequired: true,
        "required": true,
        "section":'beneficiaryInfo'
      }, 
      {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "email",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "SSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "lastArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "I94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "passportNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "passportIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "passportExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "curNonImmigrantVisaStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "curVisaExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "cellPhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "cellPhoneCountryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "cellPhoneCountryCode"
      },
      {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "cellPhoneCountryCode"
      },
      {
        "key": "homePhoneNumber",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": false,
        "section": "beneficiaryInfo"
      },
      {
        "key": "passportIssuedCountry",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": false,
        "section": "beneficiaryInfo"
      },
      {
        "key": "maritalStatus",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": false,
        "section": "beneficiaryInfo"
      },
      {
        "key": "gender",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": false,
        "section": "beneficiaryInfo"
      },



      {
           

        "key": "proofOfCurrentStatus",
        "lebel": "",
        "required": true,
        "description": "Proof Of Current Status",
        "fieldRequired": true,
        "section": "documents"
		  	},
			{
       


        "key": "copyOfExistingVisa",
        "lebel": "",
        "required": true,
        "description": "Copy Of Existing H4",
        "fieldRequired": true,
        "section": "documents"


			},
      {

        "key": "copyOfExistingL2Visa",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents"

      },
      {
        "key": "priorL2Approvals",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents"
      },
			{
        

        "key": "approvalCopyOfI140",
        "lebel": "",
        "required": true,
        "description": "Approval Copy Of I-140",
        "fieldRequired": true,
        "section": "documents"

			},



      {
        "key": "priorH4Approvals",
        "lebel": "",
        "required": true,
        "description": "All prior H4 approvals, if any",
        "fieldRequired": true,
        "section": "documents"
      },
      {
        "key": "passport",
        "lebel": "",
        "required": true,
        "description": "Passport- First page with photo and last page with address",
        "fieldRequired": true,
        "section": "documents"
      },
      {
        "key": "usVisa",
        "lebel": "",
        "required": true,
        "description": "US Visa",
        "fieldRequired": true,
        "section": "documents"
      },
      {
        "key": "mostRecentI94",
        "lebel": "",
        "required": true,
        "description": "Most recent I-94",
        "fieldRequired": true,
        "section": "documents"
      },
      {
        "key": "ssnCard",
        "lebel": "",
        "required": true,
        "description": "SSN Card, if any",
        "fieldRequired": true,
        "section": "documents"
      },
      {
        "key": "marriageCertificate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents"
      },
      {
        "key": "eadCard",
        "lebel": "",
        "required": true,
        "description": "Prior EAD Cards, if any ",
        "fieldRequired": true,
        "section": "documents"
      },
      {

        key: 'other',
        lebel: 'Others',
        description:'',      
        fieldRequired: true,
        "required": true,
        "section":'documents'

        
        },
           
      // {
      //   "key": "travelHistory",
      //   "lebel": "",
      //   "required": true,
      //   "description": "",
      //   "fieldRequired": true,
      //   "section": "documents"
      // },

      //spouse Documents
      {
            key: 'approvedI140',
            lebel: 'Approved I-140 or Pending Perm for more than 365 days',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
           
          }, 
          {
            
            key: 'h1Bapprovals',
            lebel: 'All H-1B approvals, all the way to CAP',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'

            
          }, 
          {
            
            key: 'l1approvals',
            lebel: 'All L1 approvals, all the way to CAP',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'

            
          }, 
          {
            

            key: 'passport',
            lebel: 'Passport',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          }, 
          {
           
            key: 'usVisa',
            lebel: 'US Visa',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          },  
           
          {
            
            key: 'mostRecentI94',
            lebel: 'Most recent I-94',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'

          },  
          {
            
            key: 'travelHistory',
            lebel: 'Travel History',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          },  
          {
            
            key: 'mostRecentPayStubs',
            lebel: '3 most recent pay stubs',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          },
          {

            key: 'other',
            lebel: 'Others',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          },
          /// chidren keys start
          {"key":"anyOtherPersonEmployedInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"dateOfLastEntryInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"applyingWithYou","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"haveYouEverTravelledToUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"isDSExpiryDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"haveYouEverEmployed","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"relationship","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"passportIssuedCountry","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"currentlyInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"hasOtherNames","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"otherNames","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"passportIssuedDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"alienNumber","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"addressOutsideUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"priorPeriodOfStayInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"gender","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"hasChildren","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"h4EADRequired","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"name","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"firstName","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"middleName","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"lastName","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"email","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"phoneNumber","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"cellPhoneNumber","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"dateOfBirth","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"countryOfBirth","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"placeOfLastEntryInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"stateOfLastEntryInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"countryOfBirthDetails","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"provinceOfBirth","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"provinceOfBirthDetails","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"locationOfBirth","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"countryOfCitizenship","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"countryOfCitizenshipDetails","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"passportNumber","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"passportExpiryDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"I94","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"I94ExpiryDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"sevisNumber","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"eadNumber","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"isI94DSExpiryDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"currentStatus","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"statusExpiryDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"doYouAlreadyH4EAD","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"maritalStatus","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"doYouWantTheSsaToIssueYouSS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"doYouHaveSSN","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"immigStatusLastArrival","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"SSN","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"firstArrivalDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"lastArrivalDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"mannerOfLastArrival","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"stateOfLastEntryInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"stateDetailsOfLastEntryInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"placeOfLastEntryInUS","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"currentAddress","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"physicalAddress","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"mailingAddressIsSameAsAddress","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"addressOutsideUSMoreThanYear","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"addressOfLastNYears","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"caseIssuedDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"caseExpiryDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"placeOfCaseIssued","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"dateFromWhichResideInUs","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"curNonImmCaseNo","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"classification","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"applyI485AdjOrConsuProcess","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"adjustmentOfI485Status","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"consularProcessing","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"adjustmentStatusToPermResidenceI485","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"height","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"weight","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"eyeColor","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"hairColor","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"nameDiffFromBirthCert","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"birthCertHaveNamePobDob","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"have2AffidavitsOfBirthFamily","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"i140PriorityDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"currentJobTitle","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"currentAnnualSalary","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"assets","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"financials","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"liabilitiesDebts","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"publicBenefits","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"fatherInfo","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"},
          {"key":"motherInfo","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens"}, 
          {"key":"slgApprovalNoticeOfPrevL2","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},

          {"key":"slgApprovalNoticeOfPrevH4","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"prevEmploymentInfo","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"employerName","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"address","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"businessType","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"salary","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"payFrequency","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"jobTitle","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"jobDuties","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"startDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"endDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"currentEmployer","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"employerName","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"address","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"businessType","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"jobTitle","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"jobDuties","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"startDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"endDate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"currentEmployer","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.prevEmploymentInfo"},
          {"key":"passport","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"visa","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"formI94","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"birthCertificate","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"approvalNotice","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"approvalNoticeOfPrevH4","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"other","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"photographs","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"medicalExamins","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"dependentForI134","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"dependentTaxReturns","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"w2","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"bankStatements","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"evidenceOfContinuVisaStatus","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"evidenceOfFilePetitionBefore30Apr2001","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"proofOfIncomeOrAsset","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"proofOfMedicalInsurence","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"recentCreditReport","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"permResidence","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"empAuth","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"I140ApprovalNotice","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"},
          {"key":"slgPrevLaborApplications","lebel":"","required":true,"description":"","fieldRequired":true,"section":"dependentsInfo.childrens.documents"}

 ],
    
    newform: {
      name: "",
      entityTypeDetails: { name: "Case", id: 1 },
      entityType: "case",
      //entityType- Case Fields
      fields: [
        // for dependents Starts
        {
          "key": "inadmissibility",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "highestDegreeCompleted",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "listOfCertifications",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "SSI",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "benefitReceived",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },
        {
          "key": "startDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },
        {
          "key": "endDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },
        {
          "key": "amount",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.benefitsRecAmounts"
        },

        {
          "key": "longTermInstiAtGovtExpense",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse"
        },
        {
          "key": "institutionName",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "stateDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "locationDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "dateFrom",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "dateTo",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "reason",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.spouse.periodOfInstutions"
        },
        {
          "key": "inadmissibility",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "highestDegreeCompleted",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "listOfCertifications",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "SSI",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "benefitReceived",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },
        {
          "key": "startDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },
        {
          "key": "endDate",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },
        {
          "key": "amount",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.benefitsRecAmounts"
        },

        {
          "key": "longTermInstiAtGovtExpense",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens"
        },
        {
          "key": "institutionName",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "stateDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "locationDetails",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "dateFrom",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "dateTo",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        {
          "key": "reason",
          "lebel": "",
          "required": true,
          "description": "",
          "fieldRequired": true,
          "section": "dependentsInfo.childrens.periodOfInstutions"
        },
        // for dependents end
      {
        "key": "inadmissibility",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "houseHoldNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "houseHoldAnnualIncome",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "houseHoldAnnualAssets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "houseHoldAnnualliabilities",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "highestDegreeCompleted",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "listOfCertifications",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "SSI",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "benefitReceived",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      {
        "key": "amount",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.benefitsRecAmounts"
      },
      {
        "key": "longTermInstiAtGovtExpense",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
      },
      {
        "key": "institutionName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "stateDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "locationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "dateFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "dateTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },
      {
        "key": "reason",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.periodOfInstutions"
      },

      {
        "key": "illegalGamblingOrDrug",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "illegalActivityOrSource",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
          "key": "benfAssets",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },

      {
          "key": "firstName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "lastName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "middleName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "typeOfAsset",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "amount",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfAssets"
        },
        {
          "key": "benfIncome",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "firstName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "lastName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "middleName",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "dateOfBirth",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "relToTheBenf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
        {
          "key": "amount",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo.benfIncome"
        },
      {
        "key": "beneficiaryCnfmNumber",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "typeOfOffice",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "officeAddress",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "i485AdditionalInformation",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everDeniedAdmissionInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "isVisaDenieedTOUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everWorkedInUSWithoutAuth",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolatedTandCofYourNonImmStatus",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everBeenInRemovalExcl",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everBeenIssuedOrderExclRemoval",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHadPriorOrderExclDeport",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHeldPermResidentStatus",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everGrantedVolDepartimmgOfficer",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAppliedReliefOrExclDeport",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everJNonImmmExchangeVistor",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCompailedForeignResi",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everGrantedWavierRecomndLtr",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everArrested",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCommittedCrime",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everPledGuilty",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everPunishedByJudge",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAccusedCrimProc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolated",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everConvictedTwoOrMoreOffens",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everIlleglTraf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everKnowinglyIlleglTraf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpouseSondaughterIlleglTraf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngageProst",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everdirOrIndirectProst",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everReceiveMoneyFronProst",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everIntentIllegalGamblUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everImmunityCriminalOffensedInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolateReliFreedomAsForeignGovOffi",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everForceFraudCommercialSexActs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everTraffPersonIntoInvolSlavery",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everKnowWithTraffPersonCommSexAct",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpouseSonDughterEngTraffAnyFinBef",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngMoneyLaundering",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolateEvidenceLawRelatedInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everViolateExpGoodsSensInfoTechInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everOverthrowingUSGovtByForceViolence",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everActivityDangerScurityOfUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngUnlawfulActivity",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngActSeriousForeignPolicyforUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCommitedKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everCommMemberGrpOrgKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAskMoneyRecruGrpKidnapHijackEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everProvideMoneyForAssiKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everProvideMoneyForAssiIndiGrpKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everTraiParaOrMilataryWepons",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiEngKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHSpoOrChiPartMemberKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiRecrutKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiAskMoneyAssiKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiForAssiIndiGrpKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSellProvideTransWepon",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everWorkedPrisionAndDetained",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everUsingWeponPartGrpOrgThreatPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everServedParaOrMilataryEtc",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everMemberCommPartyInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "ever080545To230393AssoNaziGerGov",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everInvolveTorture",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everKillAnyPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSeverInjuAnyPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEngAnySexualContent",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everLimitReligBnf",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everUsedBelow15yrsPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everHelpUnder15yrsPerson",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRcvPublicAssiInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everFutureRcvPublicAssiInUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAttenRmvProcFiledAfter010497",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRmvProcFiledReason",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "rmvProcFiledResonWriteStmt",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSubmitFraudDocUSGov",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everLiedMisrepreInfoEnterUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everClaimFlaslyUSCitizen",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everStowawayOnVessel",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everTrytoEnterUsIllegaly",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everFinalOrderCivilPenalty",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRemovedfromUs",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everEnterUSWithoutInspAdmit",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497More180DLessYrULFStayUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497YrOrMoreULFDepartUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497ReEntMoreYrULFStayUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everSince010497RmvFromUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "planForPractPolyInUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "AreYouAccomOtherCountry",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAnyUsChildUnderCustody",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everVoilationAnyFedaral",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everUsCtzshipAvoidTax",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAppliedForExemptServiceUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everReliServTrainAreYouForeignNation",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everConvictDestUSArmedForce",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "everRemOutsideUSAviodTrainArmedForce",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "nationImgrstaIfAviodTrainArmForcUS",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "criminalActsAndViolationsAddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "genEligAndInadmisGroundsQ46aTo50AddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "genEligAndInadmisGroundsQ51AddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "genEligAndInadmisGroundsQ52To60AddiInfo",
        "lebel": "",
        "fieldRequired": true,
        "required": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "h4EadPhotoEmailStmt",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hasSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "last12MonthsPayslips",
        "lebel": "Beneficiary’s Pay Slips",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proExecOrmanagerial",
        "lebel": "Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfVeriPoliBenfApproved",
        "lebel": "Copies of various policies Beneficiary approved",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfContExecByBeneficiary",
        "lebel": "Copies of Contracts executed by Beneficiary",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "copyOfBoardMinBenfPlayRole",
        "lebel": "Copies of Board Minutes where Beneficiary played a role",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "payRevisionLetters",
        "lebel": "Pay Revision Letters (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "leaveAppliForms",
        "lebel": "Leave Application Forms (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "manageManPowerReq",
        "lebel": "Manage Manpower Request (Exhibit 14)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetterFromUSComp",
        "lebel": "Offer letter from the US Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAgreementFromUSComp",
        "lebel": "Employment Agreement from the US Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetterFromForeComp",
        "lebel": "Offer letter from the Foreign Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAgreementFromForeComp",
        "lebel": "Employment Agreement from the Foreign Company",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "trainingCert",
        "lebel": "Training Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfSpecKnowledge",
        "lebel": "Proof of specialized knowledge (Note: Technical and functional knowledge)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpousePassport",
        "lebel": "Copy of all the pages of the passport of your spouse (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMarriageCertificate",
        "lebel": "Copy of the Marriage Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseBirthCertificate",
        "lebel": "Copy of the Birth Certificate of the Spouse",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMarriagePhotographs",
        "lebel": "Photographs of the marriage and after marriage photographs of the couples",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseAffidavits",
        "lebel": "Affidavits from the parents of you and your spouse confirming your bona fide marital relationship",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpouseMartialRelationship",
        "lebel": "Any other document that show the ongoing martial relationship",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSpousePhotographs",
        "lebel": "Two (2) passport sized photographs of your spouse",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherPassport",
        "lebel": "Copy of all the pages of the passport of your father (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherBirthCertificate",
        "lebel": "Copy of your birth certificate showing your name and your parents’ names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorFatherParentsMarriageCertificate",
        "lebel": "Copy of your parent’s marriage certificate establishing that your father was married to your mother before you were born.  If marriage certificate is not available, please provide affidavits from two persons who have the personal knowledge of your parents’ marriage and your birth",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorMotherPassport",
        "lebel": "Copy of all the pages of the passport of your mother (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorMotherBirthCertificate",
        "lebel": "Copy of your birth certificate showing your name and your mother’s",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingPassport",
        "lebel": "Copy of all the pages of the passport of your sibling (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBirthCertWithParents",
        "lebel": "Copy of your birth certificate showing your name and your parents’ names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBirthCertificate",
        "lebel": "Copy of your sibling’s birth certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorSiblingBffidavits",
        "lebel": "Affidavits from the parents of you and your sibling confirming your relationship (format will be provided by our office)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildPassport",
        "lebel": "Copy of all the pages of the passport of your child (including the blank pages)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildBirthCertWithParents",
        "lebel": "Copy of your child’s birth certificate showing child’s name both parents’ name, and your marriage certificate to the child’s mother- if you are the child’s father",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "sponsorChildBirthCertificate",
        "lebel": "Copy of your child’s birth certificate showing child’s name and your name- if you are the child’s mother",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "marriageEndedOtherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "marriageEndedOtherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "sponsorInfo.fatherInfo"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfMarriageEnd",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "marriageEndedDueTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "obtainPermResidenceThroughSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "locationOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "countryOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "previousSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.previousSpouse"
    },
    {
        "key": "dateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "dateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "hasChildren",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "noOfTimesMarriedBeneficiary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "noOfChildrens",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "doYouHaveMarriageCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "marriageCertDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "have2AffidavitsAttestingToMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "race",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "race",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "nameDiffFromBirthCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "birthCertHaveNamePobDob",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "have2AffidavitsOfBirthFamily",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "previouslyMarried",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "previousSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "maidenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "dateOfMarriageEnd",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "countryOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "provinceOfMarriageTerminationDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "locationOfMarriageTermination",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "obtainPermResidenceThroughSpouse",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOfLastNYears"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOfLastNYears"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.addressOfLastNYears"
    },
    {
        "key": "caseIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "caseExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "placeOfCaseIssued",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "dateFromWhichResideInUs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "curNonImmCaseNo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "classification",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "inspectedByAnyImmOfficer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "issuedAnyEADFromUSCIS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "enterInUSUnderCaseWaiverProgram",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasPermResidencyInOtherCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "permResidencyCountryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "permResidencyCountryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "everAppliedAOSInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "i140PriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentJobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentAnnualSalary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "anyOtherPersonEmployedInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "assets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "financials",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "liabilitiesDebts",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "publicBenefits",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentlyInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveOwnershipInterest",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "ownershipInterestDesc",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevH1bCaseStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverAppliedH1bCase",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevH1bCaseDesc",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyImmPetitionFiledDesc",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "consulateInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "haveYouEverEmployed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "sponsorInfo"
    },
    {
        "key": "alienNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "firstArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "lastArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "mannerOfLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "stateDetailsOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "educations",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "graduatedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "attendedFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "attendedTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "graduatedYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "isAccredited",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "isForProfit",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.educations"
    },
    {
        "key": "haveYouEverTravelledToUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverTravelledToUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverTravelledToUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "nonImmPetitionsInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "h1bImmPetitionsInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "didThisPtnrFliedImmPetitionEarlier",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyImmPetitionFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "immPetitionPriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyOtherAlienFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "filedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "rirOrRegularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "filedStateId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "filedStateDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "applCurStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "seekingFiledDateforETA750",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "anyI140Filed",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo"
    },
    {
        "key": "fieldDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "priorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "eb2orEb3",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "currentStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.immPetitionInfo.i140Info"
    },
    {
        "key": "feet",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.height"
    },
    {
        "key": "inches",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.height"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "race",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "prevEmploymentInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "prevEmploymentInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentInfo"
    },
    {
        "key": "addressOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "gender",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "email",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "education",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.education"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.education"
    },
    {
        "key": "maritalStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfCitizenship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryOfCitizenshipDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I94ExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "isI94DSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I94StatusName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "homePhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "homePhoneCountryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "homePhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "homePhoneCountryCode"
    },
    {
        "key": "cellPhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "cellPhoneCountryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "cellPhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "cellPhoneCountryCode"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "mailingAddressIsSameAsAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "consulateNotifyAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "SSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasI140ImmPetitionFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "I140ImmPetitionFiledDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasMasterDegreeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportIssuedCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "passportIssuedCountryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "allIssuedPassportData",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "curNonImmigrantVisaStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "curVisaExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "isDSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "sevisNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "eadNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "priorPeriodOfStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "noOfDaysStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "confirmDaysStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasApprovedI140",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasPermPendingForMorethan365Days",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "applyI485AdjOrConsuProcess",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "adjustmentOfI485Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "hasAnyDependetsinUStoFileH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "consularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "areYouUnderRemoveOfIndOrUscis",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "anyImmPetitionFiled",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "relationship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportIssuedCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentSpouseName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "isDSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doYouHaveSSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "immigStatusLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnFather"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnFather"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnMother"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.ssnMother"
    },
    {
        "key": "doYouWantTheSsaToIssueYouSS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "maritalStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "presentMaritalStatusDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentlyInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "alienNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "addressOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUS"
    },
    {
        "key": "priorPeriodOfStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "gender",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "l2Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "h4Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doYouAlreadyH4EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "h4EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "l2EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doYouAlreadyL2EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "email",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "phoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.phoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.phoneCountryCode"
    },
    {
        "key": "cellPhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.cellPhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.cellPhoneCountryCode"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfCitizenship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfCitizenshipDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "passportExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "allIssuedPassportData",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "countryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "number",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "issuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "expiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.allIssuedPassportData"
    },
    {
        "key": "I94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "I94ExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "sevisNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eadNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "isI94DSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "statusExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "SSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "firstArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "lastArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "mannerOfLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "stateDetailsOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "mailingAddressIsSameAsAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "physicalAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUSMoreThanYear"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOutsideUSMoreThanYear"
    },
    {
        "key": "dateOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "dateOfMarriageEnd",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "countryOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "provinceOfMarriageDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "locationOfMarriage",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOfLastNYears"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.addressOfLastNYears"
    },
    {
        "key": "caseIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "caseExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "placeOfCaseIssued",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "dateFromWhichResideInUs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "curNonImmCaseNo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "classification",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "feet",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.height"
    },
    {
        "key": "inches",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.height"
    },
    {
        "key": "applyI485AdjOrConsuProcess",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "adjustmentOfI485Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "consularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "adjustmentStatusToPermResidenceI485",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "nameDiffFromBirthCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "birthCertHaveNamePobDob",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "have2AffidavitsOfBirthFamily",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "i140PriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "attendedFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "attendedTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "graduatedYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "isAccredited",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "isForProfit",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.educations"
    },
    {
        "key": "currentJobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentAnnualSalary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "anyOtherPersonEmployedInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentInfo"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "prevEmploymentOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo.prevEmploymentOutsideUS"
    },
    {
        "key": "assets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "financials",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "liabilitiesDebts",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "publicBenefits",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "fatherInfo.nameAtBirth"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "motherInfo.nameAtBirth"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.otherNames"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.otherNames"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.otherNames"
    },
    {
        "key": "deceasedDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "deceasedCity",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "dateFromUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "isUSCitizen",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "natureofAssociations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.associations"
    },
    {
        "key": "marriageEndedDueTo",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo.previousSpouse"
    },
    {
        "key": "curNonImmigrantVisaNumber",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "doesBirthRegistered",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "isVisaDenieedTOUS",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "visaDeniedReason",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYoueverPresntUnlawfully",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "presntUnlawfullyReason",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverReceivedPublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "eadCard",
        "lebel": "Please provide a copy of the EAD CARD(S), front and  back",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "documents"
    },
    {
        "key": "haveYouArrestedBefore",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouArrestedBeforeDocs",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "beneficiaryInfo"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "associations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "natureofAssociations",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "fieldRequired": true,
        "description": "",
        "section": "dependentsInfo.spouse.associations"
    },
    {
        "key": "isVisaDenieedTOUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "visaDeniedReason",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYoueverPresntUnlawfully",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "presntUnlawfullyReason",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverReceivedPublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouEverlikelyReceivePublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "haveYouEverlikelyReceivePublicAssistendeInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "everAppliedAOSInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "appliedAOSInUSDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "beneficiaryInfo"
    },
    {
        "key": "appliedAOSInUSDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouArrestedBefore",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "haveYouArrestedBeforeDocs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "doesBirthRegistered",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "curNonImmigrantVisaNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "enterInUSUnderCaseWaiverProgram",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "inspectedByAnyImmOfficer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "issuedAnyEADFromUSCIS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "hasPermResidencyInOtherCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "permResidencyCountryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "permResidencyCountryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "eadCard",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "applyingWithYou",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse"
    },
    {
        "key": "applyingWithYou",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "visa",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "formI94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "formI797",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "formI20",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "payStubs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "marriageCertificate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "noticeOfApprovalOfH1Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "approvalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "other",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "birthCertificate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "photographs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "medicalExamins",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "dependentForI134",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "dependentTaxReturns",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "w2",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "bankStatements",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "evidenceOfContinuVisaStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "evidenceOfFilePetitionBefore30Apr2001",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "proofOfIncomeOrAsset",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "proofOfMedicalInsurence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "recentCreditReport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "permResidence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "empAuth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "I140ApprovalNotice",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "slgPrevLaborApplications",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "slgApprovalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.documents"
    },
    {
        "key": "relationship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportIssuedCountry",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentlyInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "hasOtherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "otherNames",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "alienNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "addressOutsideUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "priorPeriodOfStayInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "gender",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "l2Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "h4Required",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "h4EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouAlreadyH4EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "l2EADRequired",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouAlreadyL2EAD",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "firstName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "middleName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "lastName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "email",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "phoneNumber",
        "lebel": "",
        "required": false,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.phoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.phoneCountryCode"
    },
    {
        "key": "cellPhoneNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.cellPhoneCountryCode"
    },
    {
        "key": "countryCallingCode",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.cellPhoneCountryCode"
    },
    {
        "key": "dateOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "provinceOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "provinceOfBirthDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "locationOfBirth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryOfCitizenship",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "maritalStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "prevEmploymentInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "anyOtherPersonEmployedInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "salary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "payFrequency",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "countryOfCitizenshipDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passportExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "countryId",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "countryDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "number",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "issuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "expiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.allIssuedPassportData"
    },
    {
        "key": "I94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "isDSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "I94ExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "sevisNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "eadNumber",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "isI94DSExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "statusExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouWantTheSsaToIssueYouSS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "doYouHaveSSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "immigStatusLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnFather"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnFather"
    },
    {
        "key": "familyName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnMother"
    },
    {
        "key": "givenName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.ssnMother"
    },
    {
        "key": "SSN",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "firstArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "lastArrivalDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "mannerOfLastArrival",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "stateOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "stateDetailsOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "placeOfLastEntryInUS",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "mailingAddressIsSameAsAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "physicalAddress",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "addressOutsideUSMoreThanYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "addressOfLastNYears",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "caseIssuedDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "caseExpiryDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "placeOfCaseIssued",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "dateFromWhichResideInUs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "curNonImmCaseNo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "classification",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "applyI485AdjOrConsuProcess",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "adjustmentOfI485Status",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "consularProcessing",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "adjustmentStatusToPermResidenceI485",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "height",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "weight",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "eyeColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "hairColor",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "nameDiffFromBirthCert",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "birthCertHaveNamePobDob",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "have2AffidavitsOfBirthFamily",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "i140PriorityDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "name",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "highestDegree",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "majorFieldOfStudy",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "attendedFrom",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "attendedTo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "graduatedYear",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "isAccredited",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "isForProfit",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.educations"
    },
    {
        "key": "currentJobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "currentAnnualSalary",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentInfo"
    },
    {
        "key": "employerName",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "address",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "businessType",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "jobTitle",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "jobDuties",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "startDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "endDate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "currentEmployer",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
    },
    {
        "key": "assets",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "financials",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "liabilitiesDebts",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "publicBenefits",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "fatherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "motherInfo",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens"
    },
    {
        "key": "passport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "visa",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "formI94",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "birthCertificate",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "approvalNotice",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "approvalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "other",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "photographs",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "medicalExamins",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "dependentForI134",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "dependentTaxReturns",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "w2",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "bankStatements",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "evidenceOfContinuVisaStatus",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "evidenceOfFilePetitionBefore30Apr2001",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "proofOfIncomeOrAsset",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "proofOfMedicalInsurence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "recentCreditReport",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "permResidence",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "empAuth",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "I140ApprovalNotice",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "slgPrevLaborApplications",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "slgApprovalNoticeOfPrevH4",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.childrens.documents"
    },
    {
        "key": "resume",
        "lebel": "Resume",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "education",
        "lebel": "Master’s/ Bachelor’s degree certificate, transcripts,12th and 10th certificates",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "expLetters",
        "lebel": "Experience Letters",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "INSNotices",
        "lebel": "I-797, Notice of Approval granting the current nonimmigrant status (if applicable)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "I140ApprovalNotice",
        "lebel": "I-140 Approval Notice, if any",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passport",
        "lebel": "Passport- First page with photo and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passportVisaI94",
        "lebel": "Passport- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI20",
        "lebel": "All Form I-20s if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "socialSecurityCardAndProfLicense",
        "lebel": "Social Security Card",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "other",
        "lebel": "Other Documents, if any",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "payStubs",
        "lebel": "Three recent pay stubs",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "offerLetter",
        "lebel": "Employment Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "clientLetter",
        "lebel": "Client Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "vendorLetter",
        "lebel": "Vendor Letter if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "msa",
        "lebel": "MSA/Service Agreement and PO/SOW",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "po",
        "lebel": "PO",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "beneficiaryDocs",
        "lebel": "Beneficiary Documents",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "h1bRegSelectionNotice",
        "lebel": "H-1B Registration Selection Notice",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "employmentAgreement",
        "lebel": "Employment Agreement",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "primeVendor",
        "lebel": "Prime Vendor Letter if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI94",
        "lebel": "Copy of I-94",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "priorFormI797",
        "lebel": "Copy of I-797, Notice of Approvals for granting of legal status in the US",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "I797NoticeofApprovalforI140",
        "lebel": "I-797, Notice of Approval for I-140 if available",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "ead",
        "lebel": "EADs (if on OPT or STEM OPT Extension)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "w2",
        "lebel": "Copy of W-2 Forms issued for all tax years till present",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "birthCertificate",
        "lebel": "Birth Certificate",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "photographs",
        "lebel": "Photographs",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "medicalExamins",
        "lebel": "Medical Examins",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "dependentForI134",
        "lebel": "Dependent For I-134",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "dependentTaxReturns",
        "lebel": "Dependent Tax Returns",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bankStatements",
        "lebel": "Bank Statements",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "evidenceOfContinuVisaStatus",
        "lebel": "Evidence of Continue Visa Status",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "evidenceOfFilePetitionBefore30Apr2001",
        "lebel": "Evidence of File Petition Before 30-Apr-2001",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfIncomeOrAsset",
        "lebel": "Proof of Income or Asset",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "proofOfMedicalInsurence",
        "lebel": "Proof of Medical Insurence",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "recentCreditReport",
        "lebel": "Recent Credit Report",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "permResidence",
        "lebel": "Permanent Residence",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "empAuth",
        "lebel": "Employment Auth",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "capSelectNotice",
        "lebel": "CAP Selection Notice",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgResume",
        "lebel": "Current Resume- Please mention the accurate names of the employer and periods of employment. Do not state the client names",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgCollegeDegreesCert",
        "lebel": "All College Degrees",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgTransScripts",
        "lebel": "Copies of all education documents including Certificates and Transcripts/Marks Memos",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgExpLetters",
        "lebel": "Letters of Experience",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPassportAndVisa",
        "lebel": "Copy of New and Old Passport along with Visa",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI94",
        "lebel": "I-94",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevNonimmApprovalNotices",
        "lebel": "Copy of all Previous Nonimmigrant Approval Notices (e.g., H-1B, H-4, L-1A, L-1B, L-2 etc.,)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevImmApprovalNotices",
        "lebel": "Copies of all prior Notice of Approvals/Receipts (if any) for legal status in the US",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI140OrPermNoties",
        "lebel": "Copy of any I-140 approval notices or PERM filing Notices (if applicable)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPrevLaborApplications",
        "lebel": "Copy of the previously filed Labor Application, if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgAckOfPrevLaborApplications",
        "lebel": "Copy of the Acknowledgement letter for the previously filed Labor application, if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgPaystubs",
        "lebel": "Copies of most recent four paystubs to the present salary drawn.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.motherInfo"
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "motherInfo"
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "dependentsInfo.spouse.fatherInfo"
    },
    {
        "key": "deceasedCityDetails",
        "lebel": "",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "fatherInfo"
    },
    {
        "key": "marriageCertificate",
        "lebel": "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "underlyingLaborApplications",
        "lebel": "Copy of the underlying Labor Certification (PERM) if applicable.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "mostRecentTaxTranscrips",
        "lebel": "A copy of Most Recent Year’s Tax Transcripts – can be obtained from",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgI20",
        "lebel": "Copies of all I-20’s.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEad",
        "lebel": "Copies of EAD cards.",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEvalOfEduCredentials",
        "lebel": "Copy of Educational Evaluation, if any (Academic Evaluation only, cannot combine with work experience, other certificates, training, etc.)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbAllCollegeDegree",
        "lebel": "Masters and/or Bachelors College Diploma/Degree",
        "required": true,
        "tooltip":"Dont upload Marksheet but only Degree here",
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbAllMastOrBachMarkSheets",
        "lebel": "All Marksheets/Transcripts",
        "tooltip":"Masters and/or Bachelors marks only",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbSubmitAllI20",
        "lebel": "Maintenance of Status - F1 Status (if on F-1 Status)",
        "required": true,
        "tooltip":"Submit all I-20's, OPT EAD cards and recent pay-statements from any employer (if working on OPT)",
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbSubSpouseOrI194OrlastTwoPays",
        "lebel": "Maintenance of Status - If on H4 or L2 Status",
        "required": true,
        "tooltip":'Submit Spouse approval, spouse I94/approval and spouse last two pay-statements',
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "spbSubMostRecAppOrI194OrTwoStatements",
        "lebel": "Maintenance of Status - If on  H1/B or L1 Status",
        "tooltip":'Submit most recent approval/I94 and last two pay-statements',
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgEvalOfEduExpCredentials",
        "lebel": "Education+Experience Evaluation",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI797H4ApprovalNotice",
        "lebel": "Form I-797 H4 approval notice if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseLatestI797",
        "lebel": "Latest I-797, Notice of Approval of the spouse (if spouse is on H-1B or L-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpousePassport",
        "lebel": "Spouse’s Passport- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseRecentPayStubs",
        "lebel": "Three recent pay stubs (if spouse is on H-1B or L-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "bnfSpouseFormAllI20",
        "lebel": "Spouse’s all Form I-20s (if spouse is on F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgOfferLetter",
        "lebel": "Unsigned Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "slgSignedOfferLetter",
        "lebel": "Signed Offer Letter",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "h4Ead",
        "lebel": "H4 EAD if applicable",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "marriageCertificate",
        "lebel": "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status)",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "formI797H1BApprovalNoticePrinNonCtzn",
        "lebel": "Form I-797 H-1B approval notice of Principal Non-citizen",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "passportOfPrinNonCtzn",
        "lebel": "Passport of Principal Non-citizen- First page with photo, Visa page and last page with address",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    },
    {
        "key": "last3MonthsPayslipsOfPrinNonCtzn",
        "lebel": "Last 3 months pay statements of Principal Non-citizen",
        "required": true,
        "description": "",
        "fieldRequired": true,
        "section": "documents",
        "efileDocTagIds": []
    }
],
      sections: [],
    },
    //entityType- Perm Fields
    permform:{
      fields: [
      {
      "key": "slgPrevLaborApplications",
      "lebel": "",
      "required": false,
      "description": "",
      "fieldRequired": false,
      "section": "documents"
    },
    {
      "key": "slgAckOfPrevLaborApplications",
      "lebel": "",
      "required": false,
      "description": "",
      "fieldRequired": false,
      "section": "documents"
    },
      {
        key: "slgTransScripts",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      
      {
        key: "slgPrevNonimmApprovalNotices",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
          key: "previousSpouse",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "firstName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "middleName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "lastName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "name",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "maidenName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "dateOfBirth",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "dateOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "dateOfMarriageEnd",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriageDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriageDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "locationOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriageTermination",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriageTerminationDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriageTermination",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "previouslyMarried",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo",
        },
        
        {
          key: "marriageEndedDueTo",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriageTerminationDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "locationOfMarriageTermination",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "obtainPermResidenceThroughSpouse",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "marriageEndedOtherInfo",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
      {
        key: "hasSpouse",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "firstName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "lastName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "maidenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "gender",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "email",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "phoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "cellPhoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "provinceOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "isDSExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "locationOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "dateOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "countryOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "placeOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "countryOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "otherCountriesOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "currentStatus",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "statusExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportIssuedCountry",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportIssuedDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "SSN",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "addressOutsideUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "hasChildren",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "firstName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "lastName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "addressOutsideUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "maidenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "gender",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "email",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "phoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "cellPhoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "provinceOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "isDSExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "locationOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "dateOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "countryOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "placeOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "countryOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "otherCountriesOfCitizenship",
        lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "dependentsInfo.childrens",
        },
      {
        key: "currentStatus",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "statusExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportIssuedCountry",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportIssuedDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "SSN",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "isTrainigRequired",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isExpRequired",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      }, 
      {
        key: "acceptAnyCombination",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isAltCombOfEduAndExpAccept",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isExpInAltOccuAccept",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "hasGainAnyExpWithEmplr",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "didEmplrPayForEdu",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isWorkingWithPetngEmplr",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "useFilingDateFromPrevSubtn",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "refilingInstructions",
      },
      {
        key: "prevFilingDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "refilingInstructions",
      },
      {
        key: "prevSWAOrLocalCaseNo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "refilingInstructions",
      },
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "firstName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "middleName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "lastName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "email",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "gender",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "currentAddress",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "mailingAddressIsSameAsAddress",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "mailingAddress",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "homePhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "homePhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "cellPhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "cellPhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "workPhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "workPhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "fax",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "faxCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "dateOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "countryOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "countryOfBirthDetails",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "provinceOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "provinceOfBirthDetails",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "locationOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },

      {
        key: "countryOfCitizenship",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "countryOfCitizenshipDetails",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      //
      {
          key: "immPetitionInfo",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo",
        },
      {
          key: "anyOtherAlienFiled",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "filedDate",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "employerName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "rirOrRegularProcessing",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "filedStateId",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "filedStateDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "applCurStatus",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "seekingFiledDateforETA750",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "anyI140Filed",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        //
      {
        key: "haveYouEverTravelledToUS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "priorPeriodOfStayInUS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      
      {
        key: "noOfDaysStayInUS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "curNonImmigrantVisaStatus",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "curVisaExpiryDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "passportNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "passportIssuedDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "passportExpiryDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      // {
      //   key: "I94",
      //   lebel: "",
      //   fieldRequired:true,
      //   required: true,
      //   description: "",
      //   section: "beneficiaryInfo",
      // },
      // {
      //   key: "I94ExpiryDate",
      //   lebel: "",
      //   fieldRequired:true,
      //   required: true,
      //   description: "",
      //   section: "beneficiaryInfo",
      // },
      {
        key: "firstEntryDateOrApprovalInUsWithH1B",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "dateFifthYearOfHExpire",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "alienNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "SSN",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "prevEmploymentInfo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
     
      {
        key: "employerName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "salary",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
          key: "payFrequency",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.prevEmploymentInfo",
        },
      {
        key: "address",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "workPhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "workPhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "fax",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "faxCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "businessType",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "jobTitle",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "jobDuties",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "jobDescription",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "startDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "endDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "hoursWorkedPerWeek",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "currentH1BEmployer",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "h1bEmployerDocuments",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "currentEmployer",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
     
      //prevEmploymentInfo.supervisor
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo.supervisor",
      },
      {
        key: "phoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo.supervisor",
      },
      {
        key: "phoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo.supervisor",
      },
      
      //educations fields
      {
        key: "educations",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "address",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "highestDegree",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "majorFieldOfStudy",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "attendedFrom",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "attendedTo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "graduatedYear",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "isAccredited",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "isForProfit",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      //beneficiaryInfo.vacationalOrTrainingInst
     
      //vacaionalOrTrainingInst fields
      {
        key: "vacationalOrTrainingInst",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "address",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "highestDegree",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "majorFieldOfStudy",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "attendedFrom",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "attendedTo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "graduatedYear",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "isAccredited",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "isForProfit",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      
      //documents
      {
        key: "slgResume",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgEduCredentials",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgEvalOfEduCredentials",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgTransScripts",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgExpLetters",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgPassportAndVisa",
        lebel: "",
        fieldRequired:true,
        description: "",
        section: "documents",
      },
      {
          key: "slgI94",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "documents",
        }, 
       
      {
        key: "slgCurPrevH1BH4ApprovalsByINS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgAdvancedDegrees",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "other",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
    ],
    },
    list: [],
    addPopup: false,
    NewPetition: false,
    searchtxt: "",
    query: [],
    country_code: 231,
    all_statusids: [],
    selected_statusids: [],
    final_selected_statusids: [],
    filter_roleIds: [],
    final_filter_roleIds: [1, 2, 3, 4, 5, 8, 9, 10, 11, 12],

    seleted_states: [],
    final_selected_states: [],
    locations: [],
    // locationIds
    final_selected_config_completed_statusids: [],
    selected_config_completed_statusids: [],

    date: "",
    date_range: [],
    page: 1,
    perpage: 25,
    totalpages: 0,
    allQuestionnairefields: [],

    switch2: true,
    users_status: {},
    edit: false,
    sortKeys: {},
    sortKey: {},
    details: null,
    getMasterData: true,
    clonePopup: false,
    templateName: "",
    creatingTpl:false,
  }),
  watch: {
    searchtxt: function (value) {
      this.getList(true);
    },
  },
  methods: {   
    
   
    gotoList() {
      this.showView(false, null, "");
      this.getList();
    },
    showView(isView = false, item = null, type = "") {
      this.type = "";
      this.templateName = this.checkProperty(item, "name");
      this.selectedItem = item;
      this.type = type;
      this.showWorkflowview = isView;
    },
    getenants() {
      let matcher = {};
      let query = {};
      query["page"] = 1;
      query["perpage"] = 10000;
      query["getMasterData"] = true;
      query["filters"] = matcher;

      this.$store
        .dispatch("getList", { data: query, path: "/tenant/list" })
        .then((response) => {
          this.tenantsList = response.list;
        });
    },
    openPopUp(item) {
      this.selectedItem = item;
      this.activatePopUp = true;
    },
    activateTemplate() {
      let postData = { questionnaireId: this.selectedItem["_id"], active: true };
      if (this.selectedItem["active"]) {
        postData["active"] = false;
      }
      this.$store
        .dispatch("commonAction", {
          data: postData,
          path: "/questionnaire/manage-active-status",
        })
        .then((res) => {
          this.activatePopUp = false;
          this.showToster({ message: res.message, isError: false });
          this.getList();
        })
        .catch((err) => {
          this.showToster({ message: err, isError: true });
        });
    },
    formandLetterDetails() {
      let query = { formAndLetterId: this.selectedItem["_id"] };
      this.$store.dispatch("formandLetterDetails", query).then((response) => {
       // alert(JSON.stringify(response));
        //this.details
      });
    },

    sortMe(sort_key = "") {
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        // this.sortKey[sort_key] = this.sortKeys[sort_key]
        this.sortKey = { path: sort_key, order: this.sortKeys[sort_key] };

        localStorage.setItem("petitiin_sort_key", sort_key);
        localStorage.setItem("formandLetter_sort_value", this.sortKey[sort_key]);
        this.getList();
      }
    },
    editMe(item) {
      if (
        _.has(item, "tenantDetails") &&
        _.has(item["tenantDetails"], "name") &&
        _.has(item["tenantDetails"], "_id")
      ) {
        this.selectedTenant = item["tenantDetails"];
      }
      this.formerrors.msg = "";
      this.edit = true;
      this.selectedItem = item;
      this.newform = { name: this.selectedItem.name };
      this.addPopup = true;
      this.clonePopup = false;
    },

    cloneMe(item) {
      this.creatingTpl =false;
      this.selectedTenant = null;
      if (
        _.has(item, "tenantDetails") &&
        _.has(item["tenantDetails"], "name") &&
        _.has(item["tenantDetails"], "_id")
      ) {
        this.selectedTenant = item["tenantDetails"];
      }
      this.formerrors.msg = "";
      this.edit = false;
      this.selectedItem = item;
      this.newform = { name: this.selectedItem.name };
      this.addPopup = false;
      this.clonePopup = true;
      //alert(this.clonePopup )
    },
    cloneTemplate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let postData = {
            name: this.newform["name"].trim(),
            questionnaireId: this.selectedItem["_id"],
          };
          if (this.selectedTenant && _.has(this.selectedTenant, "_id")) {
            postData = Object.assign(postData, { tenantId: this.selectedTenant["_id"] });
          }
          //alert(this.selectedItem['_id']);
          this.creatingTpl =true;
          this.$store
            .dispatch("commonAction", { data: postData, path: "/questionnaire/clone" })
            .then((response) => {
              this.creatingTpl =false;
              //alert(JSON.stringify(response))
              Object.assign(this.formerrors, {
                msg: "",
              });
              this.showToster({ message: response.message, isError: false });

              this.addPopup = false;
              this.edit = false;
              this.clonePopup = false;

              if (this.selectedTenant && _.has(this.selectedTenant, "_id")) {
                this.searchtxt = "";
                this.final_active_statusids = [];
                this.selected_active_statusids = [];
                this.selected_statusids = [];
                this.final_selected_statusids = [];
                this.final_selected_config_completed_statusids = [];
                this.selected_config_completed_statusids = [];

                this.date = "";
                this.date_range = [];
                this.selected_createdDateRange["startDate"] = "";
                this.selected_createdDateRange["endDate"] = "";

                this.filteredTenants = [];
                this.finalFilteredTenants = [];
                this.filteredTenants.push(this.selectedTenant);
                this.finalFilteredTenants.push(this.selectedTenant["_id"]);
              }

              this.getList();
              this.createNew(false);
              // this.clonePopup =false;
              this.selectedItem = response;
              this.showView(true, this.selectedItem, "edit");
            })
            .catch((error) => {
              this.creatingTpl =false;
              Object.assign(this.formerrors, {
                msg: error,
              });
            });
        }
      });
    },
    createNew(action = true) {
      this.creatingTpl =false;
      this.selectedTenant = null;
      this.formerrors.msg = "";
      this.edit = false;
      this.clonePopup = false;
      this.newform.name ='';
      this.newform.entityTypeDetails ={ name: "Case", id: 1 };
      this.newform.entityType ='case';
      this.addPopup = action;
      //this.$router.push("/questionnaire-config-add");
    },

    deleteConform(item) {
      this.selectedItem = item;
      this.approveConformpopUp = true;
      this.edit = false;
    },

    getList(callFromSerch = false) {
      this.callFromSerch = callFromSerch;

      if (this.callFromSerch) {
        this.list = [];
      }

      let item = {
        filters: {
          title: this.searchtxt.trim(),
          createdDateRange: [],
          statusList: [], //this.final_selected_statusids,
          activeList: this.final_active_statusids,
          configList: this.final_selected_config_completed_statusids,
          tenantIds: this.finalFilteredTenants,
        },
        getMasterData: false,
        page: this.page,
        perpage: this.perpage,
        sorting: this.sortKey,
        //getMasterData:this.getMasterData
      };

      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        item["filters"]["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"],
        ];
      }
      // alert(JSON.stringify(item));
      this.updateLoading(true);
      this.$store
        .dispatch("getList", { data: item, path: "/questionnaire/list" })
        .then((response) => {
          this.updateLoading(false);
          this.list = response.list;
          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //alert(this.perpage);
        })
        .catch((err) => {
          this.updateLoading(false);
          this.list = [];
        });
    },
    updateformandLetter() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let postData = { name: this.newform.name, category: "petition_types" };
          postData["name"] = postData["name"].trim();

          postData = Object.assign(postData, { mDataId: this.selectedItem["id"] });
          this.$store
            .dispatch(" ConfigTemplate", postData)
            .then((response) => {
              this.showToster({ message: response.message, isError: false });
              this.getList();
              this.addPopup = false;
              this.edit = false;
            })
            .catch((error) => {
              Object.assign(this.formerrors, {
                msg: error,
              });
              //this.showToster({message:"Somthin went wrong..!",isError:true});
            });
        }
      });
    },
    createConfigTemplate() {
      Object.assign(this.formerrors, { msg: ''})
      this.$validator.validateAll('templateForm').then((result) => {
        if (result) {
          let postData = this.newform;
          if (this.checkProperty(this.newform, "entityTypeDetails", "id")==2) {
            // postData["entityType"] = this.checkProperty( this.newform,"entityTypeDetails","name" );
            postData["entityType"]= "perm"
          }else{
            postData["entityType"]= "case"
          }
          //postData["entityType"] == "perm" 
          if (this.checkProperty(this.newform, "entityTypeDetails", "id")==2) {
            postData["fields"] = this.permform["fields"];
          }

          //H4 Template

          if (this.checkProperty(this.newform, "entityTypeDetails", "id")==3) {

            postData["entityType"]= "h4-ead";
            postData["fields"] = this.h4Eadfields;



          }
          if (this.checkProperty(this.newform, "entityTypeDetails", "id")==4){
            postData["entityType"]= "I-130"
            //sponsorInfo postData["fields"] 
            _.forEach(this.sponsorInfo,(item)=>{
              postData["fields"].push(item);
            });
          }
          if (this.checkProperty(this.newform, "entityTypeDetails", "id")==5){
            postData["entityType"]= "L-VISA"
            _.forEach(this.petitionerQuestInfo,(item)=>{
              postData["fields"].push(item);
            });
          }
          if (this.checkProperty(this.newform, "entityTypeDetails", "id")==6){
            postData["entityType"]= "l2"
            postData["fields"] = this.h4Eadfields;
          }

          postData["name"] = postData["name"].trim();
          if (this.selectedTenant && _.has(this.selectedTenant, "_id")) {
            postData = Object.assign(postData, { tenantId: this.selectedTenant["_id"] });
          }
          this.creatingTpl =true;
          this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/questionnaire/create",
            })
            .then((response) => {
              this.showToster({ message: response.message, isError: false });
              this.getList();
              this.addPopup = false;
              this.createNew(false);
             this.newform.name = null;
             this.creatingTpl =false;

              setTimeout(() => {
                this.showView(true, response, "edit");
                // if (this.checkProperty(this.newform, "entityTypeDetails", "id")==1) {
                //   this.$router.push("/h1b-questionnaire-template/" + response["_id"]);
                // } else {
                //   this.$router.push("/perm-questionnaire-template/" + response["_id"]);
                // }

                // this.$router.push("/h1b-questionnaire-template/" + response["_id"]);
              }, 10);
              this.$validator.reset();
            })
            .catch((error) => {
              this.creatingTpl =false;
              Object.assign(this.formerrors, {
                msg: error,
              });
            });
        }
      });
    },

    questionnaireFields() {
      const item = {
        page: 1,
        perpage: 10000,
        category: "questionnaire_fields",
      };

      this.$store.dispatch("getMasterData", item).then((response) => {
        this.allQuestionnairefields = response.list;
        //alert(JSON.stringify(response.list))
      });
    },

    set_filter: function () {
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      this.final_selected_statusids = [];
      if (this.selected_statusids.length > 0) {
        this.final_selected_statusids = [];
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }

      this.final_selected_config_completed_statusids = [];
      if (this.selected_config_completed_statusids.length > 0) {
        this.final_selected_config_completed_statusids = [];
        for (let ind = 0; ind < this.selected_config_completed_statusids.length; ind++) {
          let current_index = this.selected_config_completed_statusids[ind];
          this.final_selected_config_completed_statusids.push(current_index["id"]);
        }
      }

      this.final_active_statusids = [];
      if (this.selected_active_statusids.length > 0) {
        this.final_active_statusids = [];
        for (let ind = 0; ind < this.selected_active_statusids.length; ind++) {
          let current_index = this.selected_active_statusids[ind];
          this.final_active_statusids.push(current_index["id"]);
        }
      }
      this.finalFilteredTenants = [];
      if (this.filteredTenants.length > 0) {
        this.finalFilteredTenants = _.map(this.filteredTenants, "_id");
      }

      //alert(this.final_selected_config_completed_statusids)

      this.getList(true);
    },
    clear_filter: function () {
      this.searchtxt = "";
      this.final_active_statusids = [];
      this.selected_active_statusids = [];
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      this.selected_statusids = [];
      this.final_selected_statusids = [];
      this.final_selected_config_completed_statusids = [];
      this.selected_config_completed_statusids = [];

      this.date = "";
      this.date_range = [];
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";

      this.filteredTenants = [];
      this.finalFilteredTenants = [];
      this.getList();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getList();
    },

    deleteformandLetter() {
      let post_data = { formAndLetterId: this.selectedItem["_id"] };
      this.$store
        .dispatch("deleteformandLetter", post_data)
        .then((response) => {
          this.approveConformpopUp = false;
          this.showToster({ message: response.message, isError: false });
          this.getList();
          this.edit = false;
        })
        .catch((er) => {
          this.showToster({ message: er, isError: true });
        });
    },
  },
  mounted() {
    this.getenants();
    this.selected_statusids = [];
    this.final_selected_statusids = [];
    this.seleted_states = [];
    this.final_selected_states = [];
    (this.sortKeys = {
      name: 1,
      createdByName: 1,
      createdOn: -1,
      updatedOn: 1,
    }),
      (this.sortKey = { path: "createdOn", order: -1 });

    if (
      localStorage.getItem("petitiin_sort_key") &&
      localStorage.getItem("petitiin_sort_value") &&
      localStorage.getItem("petitiin_sort_value") >= -1
    ) {
      this.sortKey = {};

      this.sortKey[localStorage.getItem("petitiin_sort_key")] = parseInt(
        localStorage.getItem("petitiin_sort_value")
      );
      this.sortKeys[localStorage.getItem("petitiin_sort_key")] = this.sortKey[
        localStorage.getItem("petitiin_sort_key")
      ];

      //alert();
    }
    if (localStorage.getItem("formandLetter_perpage")) {
      this.perpage = parseInt(localStorage.getItem("formandLetter_perpage"));
    }

    //this.questionnaireFields();
    this.getList();
    this.type = "";
    this.showWorkflowview = false;
    
  },
};
</script>